const LocalStorageWrapper = {
	get<Type>(key: string): Type | null {
		try {
			const json = localStorage.getItem(key);
			if (json) {
				const value: Type = JSON.parse(json);
				return value;
			}
			return null;
		} catch (error) {
			return null;
		}
	},
	set(key: string, value: unknown) {
		try {
			const json = JSON.stringify(value);
			localStorage.setItem(key, json);
			return true;
		} catch (error) {
			return false;
		}
	},
	remove(key: string) {
		localStorage.removeItem(key);
	},
	clear() {
		localStorage.clear();
	},
};

export const LocalStorageKeys = {
	THEME: 'Theme',
	LOCALE: 'Locale',
	USER: 'User',
	ROLES: '_HUTO827G(595',
	AUTH_TOKEN: '_JAHSG_HJHDSG',
	REFRESH_TOKEN: '_AASMLDJJ',
	USER_STORE: '_ASDKNB',
	STORE_ROLES: '_HUTO8*(G(100',
	AUTH_STORE_TOKEN: '_JAJDKNG_HJHDSS',
	REFRESH_STORE_TOKEN: '_AASMADXDUU',
	CART: '_CART',
};

export default LocalStorageWrapper;
